import { Service } from '@mews-commander/data-access';
import { useService } from '@mews-commander/legacy-entities/src/utils/useService';
import { ServiceName as ServiceNameComponent } from '../ServiceName';

interface ServiceNameProps {
    id: string;
}

export const ServiceName: React.FC<ServiceNameProps> = ({ id }) => {
    const service = useService(id);
    if (!service) {
        return null;
    }
    return <ServiceNameComponent service={service as unknown as Service} />;
};
